import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import BillpunchTermsAndConditions from "./SalaryWeb/Billpunchterms_condition";
import Billpunchcontact from "./SalaryWeb/Billpunch_Contactus";
import Billpuncfaq from "./SalaryWeb/Billpunch_faq";
import Billpunchcancellationpolicy from "./SalaryWeb/Billpunchancellation";
import Slug from "./SalaryWeb/Slug";
import Author from "./SalaryWeb/Author";
import Blog from "./SalaryWeb/Blogs";
import Billpunchrefundpolicy from "./SalaryWeb/Billpunch_refundpolicy";
import Singlesignon from "./SalaryWeb/Login";
import Appidsecret from "./SalaryWeb/IdSecret";
import Billpunchprivacypolicy from "./SalaryWeb/Billpunch_privacypolicy";
import Attendance from "./SalaryWeb/Attendance";
import Employeemanagment from "./SalaryWeb/Employeemanagement";
import Taskmanagment from "./SalaryWeb/Taskmanagement";
import Projectmanagment from "./SalaryWeb/Projectmanagement";
import Workspacemanagment from "./SalaryWeb/Workspacemanagement";
import Expensemanagement from "./SalaryWeb/Expensemanagement";
import Leavemanagement from "./SalaryWeb/Leave";
import Payrollmanagement from "./SalaryWeb/Payroll";
import Identity from "./SalaryWeb/Identity";
import Billpunchaboutus from "./SalaryWeb/BillpunchAboutus";
import Pricing from "./SalaryWeb/Pricing";
import LandingPage from "./SalaryWeb/landingpage";
import VoiceAssistant from "./SalaryWeb/VoiceAssistant";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/terms-and-conditions" element={<BillpunchTermsAndConditions />} />
        <Route path="/contact_us" element={<Billpunchcontact />} />
        <Route path="/faq" element={<Billpuncfaq />} />
        <Route path="/terms_condition" element={<BillpunchTermsAndConditions />} />
        <Route path="/cancellation_policy" element={<Billpunchcancellationpolicy />} />
        <Route path="/blog/:post_slug" element={<Slug />} />
        <Route path="/author/:author_slug" element={<Author />} />
        <Route path="/Blogs" element={<Blog />} />
        <Route path="/refund_policy" element={<Billpunchrefundpolicy />} />
        <Route path="/New_login" element={<Singlesignon />} />
        <Route path="/Generate_ID_Secret" element={<Appidsecret />} />
        <Route path="/privacy_policy" element={<Billpunchprivacypolicy />} />
        <Route path="/best-attendance-management-system-india-2025" element={<Attendance />} />
        <Route path="/employee-management-payroll-software-india" element={<Employeemanagment />} />
        <Route path="/best-task-management-software-india-2025" element={<Taskmanagment />} />
        <Route path="/best-project-management-software-india-2025" element={<Projectmanagment />} />
        <Route path="/best-workspace-management-software-india-2025" element={<Workspacemanagment />} />
        <Route path="/best-expense-management-software-india-2025" element={<Expensemanagement />} />
        <Route path="/Leave_Management" element={<Leavemanagement />} />
        <Route path="/best-payroll-management-software-india-2025" element={<Payrollmanagement />} />
        <Route path="/Identity" element={<Identity />} />
        <Route path="/About_us" element={<Billpunchaboutus />} />
        <Route path="/Pricing" element={<Pricing />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>

      {/* <VoiceAssistant /> */}
    </Router>
  );
}

export default App;
